import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../../api/queries/getModuleSpecs';
import { ModuleType } from '../../../../api/types';
import LoadingElement from '../../../../components/LoadingElement';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import UpdateAutoplaySettingInnerPage from './UpdateAutoplaySettingInnerPage';

const UpdateAutoplaySettingPage = () => {
    const { moduleId, settingId } = useParams<{ moduleId: string; settingId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    if (module.__typename !== ModuleType.AutoplayModule) {
        return <NotFoundResult />;
    }

    const setting = module.settings.find(item => item.id === settingId);

    if (!setting) {
        return <NotFoundResult />;
    }

    return <UpdateAutoplaySettingInnerPage autoplaySettings={setting} module={module} />;
};

export default UpdateAutoplaySettingPage;
